// ===================== Stages / maps =====================
// Vampire-Survivors-style stages: pick one, then survive its `duration` against
// continuously escalating, time-based spawns. Bosses arrive on a timer and drop
// treasure chests; when the clock runs out the region's FINALE boss arrives.
// Each stage has its own biome, enemy roster, boss pool and finale. Stages
// unlock with banked coins.

export const STAGES = [
  {
    id: 'meadow',
    name: 'The Meadow',
    blurb: 'Rolling green plains. A gentle place to die.',
    ground: { a: '#14351c', b: '#173d20', grid: 'rgba(120,220,140,0.05)' },
    fog: 'rgba(10,30,16,0.0)',
    decor: ['bush', 'flower', 'rock', 'mushroom'],
    decorDensity: 0.10,
    enemies: ['slime', 'bat', 'hornet', 'sporeling'],
    elites: ['brute', 'spawnling'],
    bosses: ['maw', 'warden'],
    duration: 1500,      // survive 25 minutes
    finaleBoss: 'reaper', // end-of-run finale boss (the engine reads this, never an id)
    difficulty: { hp: 1.0, dmg: 1.0, rate: 1.0, coin: 1.0 },   // the baseline
    cost: 0,
  },
  {
    id: 'cavern',
    name: 'Crystal Cavern',
    blurb: 'Glittering depths crawling with things that bite.',
    ground: { a: '#161326', b: '#1b1730', grid: 'rgba(140,180,255,0.05)' },
    fog: 'rgba(20,10,40,0.12)',
    // Multiply-composited biome darkness (render.js drawDarkness): everything
    // luminous carves a light hole, so the cave reads lit-by-the-neon.
    darkness: { color: '#4a5490', alpha: 0.5 },
    decor: ['crystal', 'rock', 'pillar', 'bones'],
    decorDensity: 0.09,
    enemies: ['spider', 'skeleton', 'golem', 'lurker'],
    elites: ['golem', 'brute'],
    bosses: ['warden', 'maw'],
    duration: 1500,
    finaleBoss: 'shardregent',
    difficulty: { hp: 1.3, dmg: 1.2, rate: 1.1, coin: 1.3 },
    cost: 40,
  },
  {
    id: 'wastes',
    name: 'Ashen Wastes',
    blurb: 'Scorched ruin where fast, hungry things roam.',
    ground: { a: '#2a1a14', b: '#301e17', grid: 'rgba(255,150,90,0.05)' },
    fog: 'rgba(50,20,10,0.14)',
    decor: ['rock', 'bones', 'pillar'],
    decorDensity: 0.08,
    enemies: ['imp', 'hound', 'charger', 'cinder'],
    elites: ['brute', 'hound'],
    bosses: ['maw', 'void'],
    duration: 1500,
    finaleBoss: 'ashtyrant',
    difficulty: { hp: 1.65, dmg: 1.45, rate: 1.2, coin: 1.6 },
    cost: 90,
  },
  {
    id: 'void',
    name: 'The Void',
    blurb: 'Beyond the world. Only the strong last here.',
    ground: { a: '#0c0820', b: '#100b28', grid: 'rgba(180,120,255,0.06)' },
    fog: 'rgba(20,5,40,0.18)',
    darkness: { color: '#40306e', alpha: 0.55 },
    decor: ['crystal', 'pillar', 'bones'],
    decorDensity: 0.07,
    enemies: ['wisp', 'voideye', 'phantom', 'wraith'],
    elites: ['phantom', 'charger'],
    bosses: ['void', 'warden', 'maw'],
    duration: 1500,
    finaleBoss: 'nullarchon',
    difficulty: { hp: 2.1, dmg: 1.75, rate: 1.3, coin: 2.0 },
    cost: 160,
  },
];

export function getStage(id) { return STAGES.find((s) => s.id === id) || STAGES[0]; }
